import SecurityPage from "@pages/profile/security";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/profile/security")({
	component: SecurityPage,
	staticData: {
		breadcrumbId: "page.profile.security.title",
		breadcrumbTitle: "Security",
	},
});
